module.exports = __webpack_public_path__ + "static/media/health-and-disease-anxiety-large@3x.8e0ff89f.png";